import { render, staticRenderFns } from "./ClosingServiceGuide.vue?vue&type=template&id=95801bb0&scoped=true&"
import script from "./ClosingServiceGuide.vue?vue&type=script&lang=js&"
export * from "./ClosingServiceGuide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95801bb0",
  null
  
)

component.options.__file = "ClosingServiceGuide.vue"
export default component.exports